<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <page-tile-title :has-back-button="true">
        <create-dialog />
      </page-tile-title>
      <!-- end page-tile-title -->

      <v-layout my-3>
        <v-flex>
          <v-card>
            <v-data-table
              :items="items"
              :headers="headers"
              :loading="isLoading"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :disable-initial-sort="true"
            >
              <template v-slot:items="props">
                <td v-text="props.item.title" />
                <td>
                  <v-chip
                    small
                    label
                    dark
                    color="info"
                  >
                    {{ props.item.total_post }}
                  </v-chip>
                </td>
                <td v-text="props.item.created_by" />
                <td v-text="formatDate(props.item.created_at)" />
                <td>
                  <!-- buttons here -->
                  <v-layout align-center>
                    <edit-dialog :item="props.item" />
                    <delete-dialog :item="props.item" />
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { fromThisDate } from '../../../../helpers/utilities'
import PageTileTitle from '@/components/Utilities/PageTileTitle'
import CreateDialog from './components/CreateDialog'
import EditDialog from './components/EditDialog'
import DeleteDialog from './components/DeleteDialog'
export default {
  components: {
    PageTileTitle,
    CreateDialog,
    EditDialog,
    DeleteDialog
  },
  data: () => ({
    headers: [
      {
        text: 'Title',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Total Post',
        sortable: false,
        value: 'total_post',
        width: '200px'
      },
      {
        text: 'Created By',
        sortable: false,
        value: 'created_by',
      },
      {
        text: 'Created At',
        sortable: false,
        value: 'created_at',
      },
      {
        text: 'Action',
        sortable: false,
        value: false,
      }
    ]
  }),
  computed: {
    ...mapGetters({
      isLoading: 'blogTags/isLoading',
      items: 'blogTags/tags',
      rowsPerPageItems: 'blogTags/rowPerPageItems',
      paginations: 'blogTags/pagination'
    }),
    ...mapState({
      totalItems: state => state.blogTags.totalItems,
    }),
    pagination: {
      get () {
        return this.paginations
      },
      set (value) {
        this.getTags(value)
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getTags(this.page)
      },
      update () {
        this.getTags(this.page)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      getTags: 'blogTags/getTags'
    }),
    formatDate (date) {
      return fromThisDate(date)
    }
  }
}
</script>

<style>
.v-table__overflow {
  overflow-x: scroll;
}
</style>

